// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#allow-write-others[disabled] ~ .custom-control-label {\n    color: #cf005880;\n}\n#allow-write-others[disabled] ~ .custom-control-label::before {\n    background-color: #cf005840;\n    border-color: #cf005880;\n}\n", ""]);
// Exports
module.exports = exports;
